import { z } from 'zod';

const requiredPositive = (label: string) =>
	z.preprocess((val) => (val === undefined || val === null ? '' : String(val)), z.string()).superRefine((v, ctx) => {
		if (!v) {
			ctx.addIssue({ code: 'custom', message: `${label} é obrigatório` });
		} else if (Number.isNaN(Number(v))) {
			ctx.addIssue({ code: 'custom', message: `${label} deve ser um número válido` });
		} else {
			const n = Number(v);
			if (n < 0) ctx.addIssue({ code: 'custom', message: `${label} não pode ser negativo` });
			else if (n === 0) ctx.addIssue({ code: 'custom', message: `${label} deve ser maior que zero` });
		}
	});

const requiredPositiveInteger = (label: string) =>
	z.preprocess((val) => (val === undefined || val === null ? '' : String(val)), z.string()).superRefine((v, ctx) => {
		if (!v) {
			ctx.addIssue({ code: 'custom', message: `${label} é obrigatório` });
		} else if (Number.isNaN(Number(v))) {
			ctx.addIssue({ code: 'custom', message: `${label} deve ser um número válido` });
		} else {
			const n = Number(v);
			if (n < 0) ctx.addIssue({ code: 'custom', message: `${label} não pode ser negativo` });
			else if (n === 0) ctx.addIssue({ code: 'custom', message: `${label} deve ser maior que zero` });
			else if (!Number.isInteger(n)) ctx.addIssue({ code: 'custom', message: `${label} deve ser um número inteiro` });
		}
	});

const foliarProductSchema = z.object({
	productClass: z.string().min(1, 'Classe do produto é obrigatória'),
	productCommercialName: z.string().min(1, 'Nome comercial é obrigatório'),
	productTradeMark: z.string().optional().default(''),
	dose: requiredPositive('Dose'),
	doseMeasurementUnit: z.string().superRefine((v, ctx) => {
		if (v !== '/ha' && v !== '/100L')
			ctx.addIssue({ code: 'custom', message: 'Unidade da dose é obrigatória' });
	}),
});

export const FoliarSchema = z.object({
	name: z.string().min(1, 'Identificação é obrigatória'),
	prop: z.string().min(1, 'Propriedade é obrigatória'),
	area: z.string().min(1, 'Área é obrigatória'),
	sectors: z.array(z.string()).min(1, 'Selecione pelo menos um setor'),
	applicationDate: z.string().min(1, 'Data da análise é obrigatória'),
	tankVolume: requiredPositive('Vol. do tanque'),
	syrupVolume: requiredPositive('Vol. de calda'),
	tanksToPrepare: requiredPositiveInteger('Nº de tanques'),
	products: z.array(foliarProductSchema).min(1, 'Adicione pelo menos um produto'),
});

export type FoliarSchemaType = z.infer<typeof FoliarSchema>;
